import { Typography } from "@mui/material"

type KanriBunruiTextProps = {
  kanriBunrui?: string | null
}
export const KanriBunruiText = ({
  kanriBunrui
}: KanriBunruiTextProps) => (
  kanriBunrui === 'D01' ? <Typography variant="body2" color='text.primary' component="div">D01:診療所 経営者（19床以下）</Typography> :
  kanriBunrui === 'D02' ? <Typography variant="body2" color='text.primary' component="div">D02:診療所 勤務医（19床以下）</Typography> :
  kanriBunrui === 'D03' ? <Typography variant="body2" color='text.primary' component="div">D03:小規模病院（20～99床）</Typography> : 
  kanriBunrui === 'D04' ? <Typography variant="body2" color='text.primary' component="div">D04:中規模病院（100～199床）</Typography> :
  kanriBunrui === 'D05' ? <Typography variant="body2" color='text.primary' component="div">D05:大病院（200～599床）</Typography> :
  kanriBunrui === 'D06' ? <Typography variant="body2" color='text.primary' component="div">D06:大規模病院（600床以上）</Typography> :
  kanriBunrui === 'D07' ? <Typography variant="body2" color='text.primary' component="div">D07:その他</Typography> :
  kanriBunrui === 'P01' ? <Typography variant="body2" color='text.primary' component="div">P01:病院 薬剤師</Typography> :
  kanriBunrui === 'P02' ? <Typography variant="body2" color='text.primary' component="div">P02:診療所 薬剤師</Typography> :
  kanriBunrui === 'P03' ? <Typography variant="body2" color='text.primary' component="div">P03:調剤薬局 薬剤師</Typography> :
  kanriBunrui === 'P04' ? <Typography variant="body2" color='text.primary' component="div">P04:その他 薬剤師</Typography> :
  <Typography variant="body2" color='text.secondary' component="div">不明</Typography>
)
